/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForceDeleteMarketplaceListingResponse } from '../../models/force-delete-marketplace-listing-response';

export interface AdminServiceForceDeleteMarketplaceListing$Params {
  listingId: string;
}

export function adminServiceForceDeleteMarketplaceListing(http: HttpClient, rootUrl: string, params: AdminServiceForceDeleteMarketplaceListing$Params, context?: HttpContext): Observable<StrictHttpResponse<ForceDeleteMarketplaceListingResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceForceDeleteMarketplaceListing.PATH, 'delete');
  if (params) {
    rb.path('listingId', params.listingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ForceDeleteMarketplaceListingResponse>;
    })
  );
}

adminServiceForceDeleteMarketplaceListing.PATH = '/api/v3/gateway/admin/marketplace/listing/{listingId}';
